/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

type FileExtension = ".png" | ".jpg" | ".jpeg" | ".pdf" | ".docx" | ".xlsx" | ".pptx" | ".csv" | ".ico" | ".gif" | ".mrt" | ".svg";

// Siehe https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
export const mimeTypeMap: { [Key in FileExtension]: string } = {
    ".csv": "text/csv",
    ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ".jpeg": "image/jpeg",
    ".jpg": "image/jpeg",
    ".pdf": "application/pdf",
    ".png": "image/png",
    ".pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ".ico": "image/x-icon",
    ".gif": "image/gif",
    ".mrt": "text",
    ".svg": "image/svg+xml"
};

export default FileExtension;
